export const ADD_APPLICATION = 'ADD_APPLICATION'
export const REMOVE_APPLICATION = 'REMOVE_APPLICATION'
export const TOGGLE_APPLICATION_CAPTURE = 'TOGGLE_APPLICATION_CAPTURE'
export const SET_APPLICAIONS = 'SET_APPLICATIONS'
